// utils/checkCourseVisibility.js
import { studentUrls } from "../Api/Auth/AppUrls";

// Helper function to map slugs to student routes
export const findStudentRouteBySlug = (slug) => {
  const slugToStudentRouteMap = {
    "live-class": studentUrls.liveClass,
    "mechanical-live-class": studentUrls.liveClassMechanical,
    tutoring: studentUrls.studentTutoring,
    "mechanical-tutoring": studentUrls.studentTutoringMechanical,
    "subscription-materials": studentUrls.studentSubscriptionMaterials,
    "mechanical-subscription-materials":
      studentUrls.studentSubscriptionMaterialsMechanical,
    "practice-hub": studentUrls.studentPracticeHub,
    "mechanical-practice-hub": studentUrls.studentPracticeHubMechanical,
    "paid-model-test": studentUrls.studentPaidModelTest,
    "mechanical-paid-model-test": studentUrls.studentPaidModelTestMechanical,
    "quiz-bank": studentUrls.studentQuizBankCivil,
    "mechanical-quiz-bank": studentUrls.studentQuizBankMechanical,
    simulator: studentUrls.studentSimulatorCivil,
    "mechanical-simulator": studentUrls.studentSimulatorMechanical,
  };

  return slugToStudentRouteMap[slug];
};

// Reverse mapping: student route to slug
const getSlugFromStudentRoute = (studentRoute) => {
  const routeToSlugMap = {
    [studentUrls.liveClass]: "live-class",
    [studentUrls.liveClassMechanical]: "mechanical-live-class",
    [studentUrls.studentTutoring]: "tutoring",
    [studentUrls.studentTutoringMechanical]: "mechanical-tutoring",
    [studentUrls.studentSubscriptionMaterials]: "subscription-materials",
    [studentUrls.studentSubscriptionMaterialsMechanical]:
      "mechanical-subscription-materials",
    [studentUrls.studentPracticeHub]: "practice-hub",
    [studentUrls.studentPracticeHubMechanical]: "mechanical-practice-hub",
    [studentUrls.studentPaidModelTest]: "paid-model-test",
    [studentUrls.studentPaidModelTestMechanical]: "mechanical-paid-model-test",
    [studentUrls.studentQuizBankCivil]: "quiz-bank",
    [studentUrls.studentQuizBankMechanical]: "mechanical-quiz-bank",
    [studentUrls.studentSimulatorCivil]: "simulator",
    [studentUrls.studentSimulatorMechanical]: "mechanical-simulator",
  };

  return routeToSlugMap[studentRoute];
};

/**
 * Check if a student route is visible based on course visibility
 * @param {Array} categoryData - The category data from AuthContext
 * @param {string} studentRoute - The student route URL to check
 * @returns {boolean} - True if visible, false otherwise
 */
export const checkStudentRouteVisibility = (categoryData, studentRoute) => {
  if (!categoryData || !studentRoute) return false;

  const slug = getSlugFromStudentRoute(studentRoute);

  // If no slug mapping exists, assume it's always visible (e.g., dashboard, profile)
  if (!slug) return true;

  // Search through categories to find the course
  for (const category of categoryData) {
    if (category.courses) {
      const course = category.courses.find((c) => c.slug === slug);
      if (course) {
        // Return true only if visibility is explicitly true
        return course.visibility === true;
      }
    }
  }

  return false;
};

/**
 * Get all visible student routes from categoryData
 * @param {Array} categoryData - The category data from AuthContext
 * @returns {Set<string>} - Set of visible student route URLs
 */
export const getVisibleStudentRoutes = (categoryData) => {
  if (!categoryData) return new Set();

  const visibleRoutes = new Set();

  categoryData.forEach((category) => {
    if (category.courses) {
      category.courses.forEach((course) => {
        if (course.visibility === true && course.slug) {
          const route = findStudentRouteBySlug(course.slug);
          if (route) {
            visibleRoutes.add(route);
          }
        }
      });
    }
  });

  return visibleRoutes;
};
